/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enumerates the configurations of photovoltaic (PV) systems within a property, based on the number of arrays and whether the peak power (kWp) is known.
 */
export type PVConfigurationV0 = 'None' | 'roofCoverageOnly' | 'OnePVArray' | 'TwoPVArrays' | 'ThreePVArrays';

export const PVConfigurationV0 = {
    None: 'None' as PVConfigurationV0,
    RoofCoverageOnly: 'roofCoverageOnly' as PVConfigurationV0,
    OnePvArray: 'OnePVArray' as PVConfigurationV0,
    TwoPvArrays: 'TwoPVArrays' as PVConfigurationV0,
    ThreePvArrays: 'ThreePVArrays' as PVConfigurationV0
};

